<div class="contentContainer">

    <!------------------------------------------------------------------------------ header -->


    <div fxLayout="row" fxLayoutAlign="space-between center" class="headerContentContainer">
        <div fxLayout="row">
            <div fxLayoutAlign="center center" class="grayLink" (click)="routeService.goBack()">
                <mat-icon class="linkIcon ft22">arrow_back</mat-icon>
            </div>
            <div>
                <h6 class="mgl10 ft500 ft16 mgb0 gray-9"> Estudiantes </h6>
            </div>
        </div>
    </div>

    <!------------------------------------------------------------------------------ Table -->
    
    <div class="tableContainer">
        <table class="fw">

            <!-- Table Header -->
            <tr class="tableHeaderContainer">
                <th>Nombre</th>
                <th>Id</th>
                <th>Email</th>
                <th>Cursos</th>
                <th>fecha Registro</th>
            </tr>

            <!-- Table data -->
            <tr *ngFor="let item of array;  let i=index">
                <td class="centertext w-20"> {{item.nombre}} </td>
                <td class="centertext w-20"> {{item.id}}</td>
                <td class="centertext w-20"> {{item.email}}</td>
                <td class="centertext w-20"> {{item.cantCursos}}</td>
                <td class="centertext w-20">
                    <span *ngIf="item.fechaRegistro" class="ft11">{{item.fechaRegistro.toDate() | date}}</span>
                </td>
            </tr>
        </table>
    </div>

</div>